import { store } from '../index'; // get store so we can do dispatches from here
import AuthActions from '../store/authRedux';
import ErrorActions from '../store/errorRedux';

export function getApiBaseUrl() {
    if (process.env.REACT_APP_ENV === 'DEV') {
        //console.log('DEV API URL: ' + process.env.REACT_APP_PROPORTAL_API_URL)
        return process.env.REACT_APP_PROPORTAL_API_URL
    } else {
        return document.location.protocol + '//' + document.location.host + '/api/'
    }
}

// VAI-1085: handle any unauthorized responses and redirect to sign out page.
export function addErrorHandler(api, excludedStatii) {
    // note: we get full access to the apisauce response object, so the level of error handling
    //       that is available with this is extensive.
    // see: https://github.com/infinitered/apisauce (bottom of page for problem codes)
    api.addMonitor(
        (response) => {
            if (response && response.status) {
                if (!(excludedStatii || []).includes(response.status)) {
                    switch (response.status) {
                        case 400:
                            // BadRequest: redirect to dashboard
                            store.dispatch(ErrorActions.setError('400 Bad Request'))
                            break;
                        case 401:
                            // Unauthorized: user not logged in, set logout message and redirect to signout page.
                            window.sessionStorage.setItem('spark.logouttype', 'error')
                            store.dispatch(AuthActions.logoutUser());
                            break;
                        case 403:
                            // Forbidden: user is not authorized for this action
                            store.dispatch(ErrorActions.setError('403 Forbidden'))
                            break;
                        case 404:
                            // NotFound: for now, show default error page with 404 message
                            store.dispatch(ErrorActions.setError('404 Not Found'))
                            break;
                        case 500:
                            // InternalServerError: for now, show default error page with 404 message
                            store.dispatch(ErrorActions.setError('500 Internal Server Error'))
                            break;
                        default: break;
                    }
                }
            }
        }
    );
}

export function buildQueryString(queryParams) {
    let queryString = ''

    if (queryParams && Object.keys(queryParams).length > 0) {
        queryString = Object.keys(queryParams).reduce((url, key) => {
            return `${url}&${key}=${queryParams[key]}`
        }, '?')
    }

    return queryString
}